import {InterviewInstance} from "@/interview/interfaces/interview";

const InterviewInstanceService = () => {
    return {
        /**
         * Check if the interview instance is finished.
         */
        isInterviewFinished(instance: Omit<InterviewInstance, "interview">): boolean {
            return !!instance.ended_at;
        },

        /**
         * Check if an interview the patient fills is completed, by them or by
         * the pharmacist at the counter: served with the backing steps.
         */
        isCompleted(instance: Omit<InterviewInstance, "interview">): boolean {
            return !!instance.completed_at;
        },

        /**
         * Check if the patient completed it themselves, rather than the pharmacist at the counter.
         */
        isCompletedByPatient(instance: Omit<InterviewInstance, "interview">): boolean {
            return instance.filler_type === 'patient_user';
        }
    };
};

export default InterviewInstanceService();
